// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__a3qe6","skeleton-loading":"style_skeleton-loading__hf_te","card_image":"style_card_image__SPF0_","cards_tag_page":"style_cards_tag_page__ZojTi"};